import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";
import { logoutMerchantUser } from "../../api/userAuth";
import { showToastMessage } from "../../utils/toastUtils";
import { logout } from "../../features/authSlice";


const LogoutPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);

  useEffect(() => {
    // popup smooth animation
    setTimeout(() => setShow(true), 50);
  }, []);

  const handleYesLogout = async () => {
    try {
      const res = await logoutMerchantUser();

      if (res.success) {
        dispatch(logout());
        showToastMessage("success", "Logged out successfully");
        window.location.href = "/";
      } else {
        showToastMessage("error", "Logout failed");
      }
    } catch (error) {
      showToastMessage("error", "Something went wrong");
    }
  };

  return (
    <div className="w-full h-screen flex items-center justify-center bg-black/40 backdrop-blur-sm">

      {/* Popup Card - Smooth Fade & Zoom using only Tailwind */}
      <div
        className={`bg-white p-8 rounded-2xl shadow-xl w-80 text-center transform transition-all duration-300
        ${show ? "opacity-100 scale-100" : "opacity-0 scale-75"}`}
      >
        <h2 className="text-xl font-semibold mb-4">
          Are you sure you want to logout?
        </h2>

        <div className="flex justify-center gap-4 mt-6">
          <button
            onClick={handleYesLogout}
            className="bg-red-500 text-white px-6 py-2 rounded-md hover:bg-red-600"
          >
            Yes
          </button>

          <button
            onClick={() => navigate("/profile")}
            className="bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400"
          >
            No
          </button>
        </div>
      </div>

    </div>
  );
};

export default LogoutPage;
